module.exports = {"id":"212231","name":"Tobias Figueiredo","rating":"71","photo":"./data/images/photos/1/212231.png","club":{"name":"Notting. Forest","logo":"./data/images/clubs/Notting.Forest.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/TobiasFigueiredo0.json
// module id = 4153
// module chunks = 0